<template>
  <px-custom-dialog v-model="dialog" content-class="rounded-card" width="1280">
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      Cotação
      <v-btn class="ml-3" icon link target="_blank" :to="linkCotacao">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
    <template>
      <px-cotacao-respostas is-modal-view
                            :cotacao-id-prop="cotacaoId"/>
    </template>
  </px-custom-dialog>
</template>

<script>
import CotacaoRespostas from '@/modules/cotacao/resposta/CotacaoRespostas.vue';

export default {
  props: {
    cotacaoId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    linkCotacao() {
      return `/cotacao/${this.cotacaoId}/respostas`;
    },
  },
  components: {
    pxCotacaoRespostas: CotacaoRespostas,
  },
};
</script>
